"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.backendEbooksAdd = void 0;
require("jquery-validation");
const jquery_1 = __importDefault(require("jquery"));
exports.backendEbooksAdd = {
    init() {
        (0, jquery_1.default)('.book_location').on('change', function () {
            if ((0, jquery_1.default)(this).val() === '2') {
                (0, jquery_1.default)('#local_settings').show();
            }
        });
        jquery_1.default.extend(jquery_1.default.validator.messages, {
            required: 'Šis laukas yra privalomas.',
            email: 'Įveskite teisingą el. pašto adresą.',
            minlength: 'Įveskite bent {0} simbolių(-ius).',
            maxlength: 'Įveskite ne daugiau kaip {0} simbolių(-ius).',
        });
        (0, jquery_1.default)(function () {
            (0, jquery_1.default)('#entity_form').validate({
                rules: {
                    book_location: { required: true },
                },
            });
            (0, jquery_1.default)('.exLink .exLinkCheckBox input')
                .on('click', function () {
                const input = (0, jquery_1.default)(this).parent().parent().find('.exLinkInput input');
                if (!(0, jquery_1.default)(this).attr('checked')) {
                    input.attr('value', '');
                    input.attr('disabled', 'true');
                }
                else {
                    input.attr('disabled', 'false');
                }
            })
                .trigger('click');
        });
    },
};
